export default __webpack_public_path__ + "static/media/log-in.0255da61.svg";